import api from "@/services/api";

export const SEARCH_TYPES = [
  "company",
  "person",
  "note",
  "meeting",
  "montageMeeting",
  "companyCourse",
  "course",
  "instructor",
  "user",
  "organisation",
  "opco",
] as const;

export type SearchType = (typeof SEARCH_TYPES)[number];

export interface SearchResult {
  type: SearchType;
  id: string;
  title: string;
  subtitle: string | null;
  parentType: string | null;
  parentId: string | null;
  rank: number;
  createdAt: string;
}

export interface SearchGroup {
  type: SearchType;
  results: SearchResult[];
}

/** L'API rejette les termes plus courts : un index trigramme ne peut pas les
 *  servir. Le respecter côté client évite un aller-retour voué à un 422. */
export const MIN_SEARCH_LENGTH = 3;

export const searchApi = api.injectEndpoints({
  endpoints: (build) => ({
    globalSearch: build.query<SearchGroup[], string>({
      query: (q) => ({ url: `/search`, params: { q } }),
    }),
  }),

  overrideExisting: true,
});

export const { useGlobalSearchQuery } = searchApi;
